import { Icon } from "./Icons";

const navigation = [
  { id: "inbox", label: "Входящие", icon: "inbox" },
  { id: "temp", label: "Временная почта", icon: "clock" },
];

const themes = [
  { id: "red", label: "Красная" },
  { id: "blue", label: "Синяя" },
  { id: "green", label: "Зелёная" },
];

export default function Sidebar({ section, theme, onTheme, onNavigate, onCompose, onLogout, open, onClose }) {
  return (
    <>
      {open && <button className="sidebarBackdrop" aria-label="Закрыть меню" onClick={onClose} />}
      <aside className={`sidebar ${open ? "sidebarOpen" : ""}`}>
        <div className="brand">
          <span className="brandMark"><Icon name="mail" size={24} /></span>
          <div><strong>WWMaxik</strong><span>MAIL SYSTEM</span></div>
        </div>
        <button className="composeButton" onClick={() => { onCompose(); onClose(); }}>
          <Icon name="compose" /> Написать письмо
        </button>
        <nav aria-label="Основная навигация">
          {navigation.map((item) => (
            <button
              key={item.id}
              className={section === item.id ? "navActive" : ""}
              onClick={() => { onNavigate(item.id); onClose(); }}
            >
              <Icon name={item.icon} /> {item.label}
            </button>
          ))}
        </nav>
        <div className="themeSetting">
          <span>Тема</span>
          <div>
            {themes.map((item) => (
              <button
                key={item.id}
                className={`themeSwatch ${item.id} ${theme === item.id ? "selected" : ""}`}
                onClick={() => onTheme(item.id)}
                title={item.label}
                aria-label={`Тема: ${item.label}`}
                aria-pressed={theme === item.id}
              />
            ))}
          </div>
        </div>
        <button className="logoutButton" onClick={onLogout}>Выйти</button>
        <div className="sidebarStatus"><span /> Система работает</div>
      </aside>
    </>
  );
}
